import React from 'react';
import { css } from '@emotion/react';

type EmailCardProps = {
  title: string;
  image: string;
  statusText: string;
};

const card = css`
  width: 342px;
  border-radius: 10px;

  @media (max-width: 1169px) {
    width: calc(50% - 20px);
  }

  @media (max-width: 767px) {
    width: 100%;
  }
  background: #fff;
  overflow: hidden;
  box-shadow:
    0px 1px 1px -0.1px rgba(0, 0, 0, 0.05),
    0px 1.98px 3.06px -0.36px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: box-shadow var(--grn-transition-fast, 200ms) ease;

  &:hover {
    box-shadow:
      0px 2px 4px -0.1px rgba(0, 0, 0, 0.08),
      0px 4px 8px -0.36px rgba(0, 0, 0, 0.06);
  }
`;

const imageWrapper = css`
  width: 100%;
  height: 339px;
  overflow: hidden;
`;

const imageStyles = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const textSection = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 32px 32px;
  height: 112px;
  justify-content: center;
`;

const titleStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #241a17;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

const badge = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border: 1px solid rgba(55, 49, 47, 0.2);
  border-radius: 112px;
  align-self: flex-start;
`;

const badgeText = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 17.8px;
  color: rgba(61, 46, 41, 0.52);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default function EmailCard({ title, image, statusText }: EmailCardProps) {
  return (
    <div css={card}>
      <div css={imageWrapper}>
        <img css={imageStyles} src={image} alt={title} />
      </div>
      <div css={textSection}>
        <p css={titleStyles}>{title}</p>
        <div css={badge}>
          <span css={badgeText}>{statusText}</span>
        </div>
      </div>
    </div>
  );
}
